import type { InputProps as AntInputProps } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { IconWrap } from '../../../icons/icon';
import { theme } from '../../../theme/semanticTokens';
import { IconSize } from '../../../types/icons/Icon.types';
import { IconType } from '../../../types/icons/IconTypes.enum';
import { Typography } from '../../../Typography';
import { Popover } from '../../Popover';

export interface InputLabelProps {
  className?: string;
  label: string;
  htmlFor?: AntInputProps['id'];
  optional?: boolean;
  infoIcon?: boolean;
  infoText?: string;
}

const LabelRow = styled.label`
  display: flex;
  align-items: center;
  gap: ${theme.dime.spacing.s};
  margin-bottom: ${theme.dime.spacing.s};
`;

const OptionalText = styled(Typography)`
  color: ${theme.dime.colors.text.secondary};
`;

const InfoIconTrigger = styled.span`
  display: inline-flex;
`;

const infoIconStyle: React.CSSProperties = { color: theme.dime.colors.icon.primary };

const InfoIcon = (
  <IconWrap type={IconType.Information} size={IconSize.Small} style={infoIconStyle} />
);

export const InputLabel: React.FC<InputLabelProps> = ({
  className,
  label,
  htmlFor,
  optional = false,
  infoIcon = false,
  infoText
}) => (
  <LabelRow className={className} htmlFor={htmlFor}>
    <Typography variant="body1Semi">{label}</Typography>
    {optional ? <OptionalText variant="body1">(optional)</OptionalText> : null}
    {infoIcon ? (
      infoText ? (
        <Popover content={infoText}>
          <InfoIconTrigger>{InfoIcon}</InfoIconTrigger>
        </Popover>
      ) : (
        InfoIcon
      )
    ) : null}
  </LabelRow>
);
